var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOval62CError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M0 35c0-7.732 6.268-14 14-14h32c7.732 0 14 6.268 14 14s-6.268 14-14 14H14C6.268 49 0 42.732 0 35Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M46 23H14C7.373 23 2 28.373 2 35s5.373 12 12 12h32c6.627 0 12-5.373 12-12s-5.373-12-12-12Zm-32-2C6.268 21 0 27.268 0 35s6.268 14 14 14h32c7.732 0 14-6.268 14-14s-6.268-14-14-14H14Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M30 53c3.314 0 6 2.239 6 5s-2.686 5-6 5-6-2.239-6-5 2.686-5 6-5Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M25 58c0 2.046 2.06 4 5 4s5-1.954 5-4v-1a1 1 0 1 1 2 0v1c0 3.477-3.313 6-7 6-3.688 0-7-2.523-7-6v-1a1 1 0 1 1 2 0v1Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13 53c3.314 0 6 2.239 6 5s-2.686 5-6 5-6-2.239-6-5 2.686-5 6-5Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M8 58c0 2.046 2.06 4 5 4s5-1.954 5-4v-1a1 1 0 1 1 2 0v1c0 3.477-3.313 6-7 6-3.688 0-7-2.523-7-6v-1a1 1 0 1 1 2 0v1Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M47 53c3.314 0 6 2.239 6 5s-2.686 5-6 5-6-2.239-6-5 2.686-5 6-5Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M42 58c0 2.046 2.06 4 5 4s5-1.954 5-4v-1a1 1 0 1 1 2 0v1c0 3.477-3.313 6-7 6-3.688 0-7-2.523-7-6v-1a1 1 0 1 1 2 0v1Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M20.666 13.5a2.5 2.5 0 0 1-2.5 2.5H6.5A2.5 2.5 0 0 1 4 13.5v-10A2.5 2.5 0 0 1 6.5 1h14.166v12.5ZM38.334 13.5a2.5 2.5 0 0 1-2.5 2.5H24.166a2.5 2.5 0 0 1-2.5-2.5V1h16.666v12.5ZM56 13.5a2.5 2.5 0 0 1-2.5 2.5H41.833a2.5 2.5 0 0 1-2.5-2.5V1H53.5A2.5 2.5 0 0 1 56 3.5v10Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#DB5C67",
  fillRule: "evenodd",
  d: "M4 12a1 1 0 0 1-1-1V3.5A3.5 3.5 0 0 1 6.5 0h47A3.5 3.5 0 0 1 57 3.5V11a1 1 0 1 1-2 0V3.5A1.5 1.5 0 0 0 53.5 2h-47A1.5 1.5 0 0 0 5 3.5V11a1 1 0 0 1-1 1Z",
  clipRule: "evenodd"
})));
SvgOval62CError.viewBox = '0 0 60 64';
const ForwardRef = /*#__PURE__*/forwardRef(SvgOval62CError);
export default ForwardRef;